import { instance2 } from "App/constants"
import { oneMonthBeforeToday, today, getLocalName } from "App/utils/helpers"
import { toFirstHoursDay, toLastHoursDay } from "utils/dates"

export const urlDelete = "/bed/historyrawatinap_delete_bed"

export const RESET_STATE_TAB_HISTORI = {
  id_kunjungan: "",
  id_rm: "",
  patient_name: "",
  rm_id: "",
  bed_name: "",
  nama_kelas: "",
  bed_id: "",
  kamar_name: "",
  date_start: today(true),
  date_finish: today(true),
  date_waiting: "",
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
    minWidth: "80px",
  },
  {
    id: "bed_name",
    disablePadding: true,
    label: "BED",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "kamar_name",
    disablePadding: true,
    label: "KAMAR",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "ruang_name",
    disablePadding: true,
    label: "RUANG",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "kelas_name",
    disablePadding: true,
    label: "KELAS",
    align: "left",
  },
  {
    id: "id_kunjungan",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "id_rm",
    disablePadding: true,
    label: "ID RM",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "patient_name",
    disablePadding: true,
    label: "NAMA RM",
    align: "left",
    minWidth: "180px",
  },

  {
    id: "no_sep",
    disablePadding: true,
    label: "NO SEP",
    align: "left",
    minWidth: "180px",
  },

  {
    id: "date_waiting",
    disablePadding: true,
    label: "TANGGAL WAITING",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "date_start",
    disablePadding: true,
    label: "TANGGAL MASUK",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "date_finish",
    disablePadding: true,
    label: "TANGGAL KELUAR",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "durasi",
    disablePadding: true,
    label: "DURASI",
    align: "left",
    minWidth: "200px",
  },

  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    minWidth: "200px",
    sort: false,
  },

  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    minWidth: "200px",
    sort: false,
  },
]

export const getAllListHistoryBed = async (formFilter, pages, limit) => {
  try {
    const api = await instance2.get("/bed/historyrawatinap_bed", {
      headers: {
        id_kunjungan: formFilter?.id_kunjungan,
        id_rm: formFilter?.id_rm,
        id_kelas_bed: formFilter?.id_kelas,
        nama_rm: formFilter?.nama_rm,
        rm_id: formFilter?.rm_id,
        nama_bed: formFilter?.nama_bed,
        tgl_mulai: toFirstHoursDay(formFilter?.tgl_mulai),
        tgl_selesai: toLastHoursDay(formFilter?.tgl_selesai),
        pages,
        limit,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getAllListHistoryBedExport = async (formFilter) => {
  try {
    const api = await instance2.get("/bed/historyrawatinap_bed_export", {
      headers: {
        id_kunjungan: formFilter?.id_kunjungan,
        id_rm: formFilter?.id_rm,
        id_kelas_bed: formFilter?.id_kelas,
        nama_rm: formFilter?.nama_rm,
        rm_id: formFilter?.rm_id,
        nama_bed: formFilter?.nama_bed,
        tgl_mulai: toFirstHoursDay(formFilter?.tgl_mulai),
        tgl_selesai: toLastHoursDay(formFilter?.tgl_selesai),
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteListHistoryBedById = async (id) => {
  try {
    await instance2.post(
      urlDelete,
      {},
      {
        headers: {
          idrawatinap_bed: id,
          user: getLocalName(),
        },
      },
    )
    return {
      state: true,
      message: "Data berhasil dihapus",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const updateHistoriTanggal = async (body) => {
  try {
    await instance2.post(
      "/bed/update_historybed",
      {
        tgl_mulai: body.tgl_mulai,
        tgl_selesai: body.tgl_selesai,
        bed_id: body.bed_id,
      },
      {
        headers: {
          idrawatinap_bed: body.idrawatinap_bed,
        },
      },
    )
    return {
      state: true,
      message: "Rencana pulang berhasil diupdate",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const RESET_STATE_FORM_FILTER = {
  id_kunjungan: "",
  id_rm: "",
  id_kelas: "",
  nama_rm: "",
  rm_id: "",
  nama_bed: "",
  kelas: "",
  tgl_mulai: oneMonthBeforeToday(),
  tgl_selesai: today(),
  pages: 1,
  limit: 10,
}
